<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentProductivityClient')">
        <h4 class="title-report font-semibold">Productivity by Client</h4>
      </a>
      <p class="text-base font-medium">Summary of billable client activity.<a href="#"></a></p>
    </div>
    <div>
      <a href="#"  @click="$emit('changeTab','ComponentByUser')">
        <h4 class="title-report font-semibold">Productivity by User</h4>
      </a>
      <p class="text-base font-medium">User summary of billing performance.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentMatterProductivityByUser')">
        <h4 class="title-report font-semibold">Matter Productivity by User</h4>
      </a>
      <p class="text-base font-medium	">User summary of billable and non-billable activity per matter.<a href="#"></a></p>
    </div>
  </vs-card>
</template>

<script>
export default {
name: "ProductivityReport"
}
</script>

<style scoped>

</style>
